/*    
<summary>
   This file is used to provide initial values or state to the AddBranchForm.
   Developer:Mohammad Saquib Khan, Created Date: 12-April-2024
</summary>
*/

import dayjs from "dayjs";
import { IAddSpecialFreeTextSchedule } from "../../models/forms/IAddUpdateWeekdayScheduler";

export const initialState: IAddSpecialFreeTextSchedule = {
  Weekday: -1,
  OrganizationId: "",
  FolderId: -1,
  PlId: -1,
  StartTime: "0000-01-01T00:00:00",
  Data1: -1,
  Data2: -1,
  Data3: -1,
  Data4: -1,
  Data5: -1,
  Data6: -1,
  ScheduleType: 0,
  StartDate: dayjs().format("YYYY-MM-DD"),
  EndDate: dayjs().format("YYYY-MM-DD"),
  EndTime: "0000-01-01T00:00:00",
};
